import script from "./DlLogUbica.vue?vue&type=script&lang=ts&setup=true"
export * from "./DlLogUbica.vue?vue&type=script&lang=ts&setup=true"

import "./DlLogUbica.vue?vue&type=style&index=0&id=5f2f4238&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f2f4238"]])

export default __exports__